function screenImg(
  isCornerUnit: boolean,
  cornerType: string = "",
  isDoubleScreenSelected: boolean = false,
  screenLayout: string
) {
  let screenImgShown = "";

  if (isCornerUnit) {
    screenImgShown =
      cornerType === "Inside"
        ? "Double Screen Inside Corner"
        : "Double Screen Outside Corner";
  } else if (isDoubleScreenSelected) {
    screenImgShown = "Double Screen";
  } else if (!isDoubleScreenSelected && screenLayout) {
    if (screenLayout.includes("Single")) {
      if (screenLayout.includes("Left")) {
        screenImgShown = "Single Screen Compress Left";
      } else if (screenLayout.includes("Right")) {
        screenImgShown = "Single Screen Compress Right";
      }
    }
  }

  return screenImgShown;
}

function screenPocketImg(
  isCornerUnit: boolean,
  oneSideOddConfig: boolean,
  oneDirectionConfig: string = "",
  isDoubleScreenSelected: boolean = false,
  screenLayout: string,
  screenPocketVal: string = ""
) {
  let screenPocketImgShown = "";

  if (isCornerUnit) {
    screenPocketImgShown = screenPocketVal || "";
  } else if (isDoubleScreenSelected) {
    if (oneSideOddConfig) {
      if (oneDirectionConfig[1] === "L") {
        screenPocketImgShown = "Add Pocket Right";
      } else if (oneDirectionConfig[1] === "R") {
        screenPocketImgShown = "Add Pocket Left";
      }
    } else {
      screenPocketImgShown = screenPocketVal;
    }
  } else if (!isDoubleScreenSelected && screenLayout) {
    if (screenLayout.includes("Single")) {
      if (screenLayout.includes("Left")) {
        screenPocketImgShown = "Single Screen Compress Left";
      } else if (screenLayout.includes("Right")) {
        screenPocketImgShown = "Single Screen Compress Right";
      }
    }
  } else if (screenPocketVal) {
    screenPocketImgShown = screenPocketVal;
  }

  return screenPocketImgShown;
}

export { screenImg, screenPocketImg };
